import { join, map } from 'ramda'

import { Dropdown, DropdownItem } from '@/components/dropdown'

import { handleDataLayerEvent } from './utils'

const SortDropdown = ({
  t,
  sort,
  updateFilters,
  optionsStyle,
  display,
  minimal
}) => {
  const SORT_BY = {
    suggested_asc: {
      value: { sort_by: 'SUGGESTED', sort_type: 'ASC' },
      label: t('filters:b.listing_filter.edit.suggested.text', 'Suggested')
    },
    created_at_desc: {
      value: { sort_by: 'CREATED_AT', sort_type: 'DESC' },
      label: t(
        'filters:b.listing_filter.edit.created_at_newest.text',
        'Date: Newest to Oldest'
      )
    },
    created_at_asc: {
      value: { sort_by: 'CREATED_AT', sort_type: 'ASC' },
      label: t(
        'filters:b.listing_filter.edit.created_at_oldest.text',
        'Date: Oldest to Newest'
      )
    },
    price_desc: {
      value: { sort_by: 'PRICE', sort_type: 'DESC' },
      label: t(
        'filters:b.listing_filter.edit.price_highest.text',
        'Price: High to Low'
      )
    },
    price_asc: {
      value: { sort_by: 'PRICE', sort_type: 'ASC' },
      label: t(
        'filters:b.listing_filter.edit.price_lowest.text',
        'Price: Low to High'
      )
    }
  }

  const sortByFilter = join('_', [
    sort?.sort_by || 'SUGGESTED',
    sort?.sort_type || 'ASC'
  ]).toLowerCase()

  return (
    <Dropdown
      value={sort || SORT_BY.suggested_asc.value}
      display={
        display
          ? `${display}:${
              SORT_BY[sortByFilter]?.label.split(':')?.[1] ||
              ` ${SORT_BY[sortByFilter]?.label}`
            }`
          : `${SORT_BY[sortByFilter]?.label || SORT_BY.suggested_asc.label}`
      }
      onChange={filterValue => {
        handleDataLayerEvent('sort')
        updateFilters({
          sort: filterValue,
          page: null
        })
      }}
      optionsStyle={optionsStyle}
      minimal={minimal}
    >
      {map(
        option => (
          <DropdownItem
            value={SORT_BY[option].value}
            key={SORT_BY[option].label}
          >
            {SORT_BY[option].label}
          </DropdownItem>
        ),
        Object.keys(SORT_BY)
      )}
    </Dropdown>
  )
}

export default SortDropdown
